<template>
  <v-layout>
    <v-flex>
      <v-layout class="color-default mb-5" justify-end>
        <router-link :to="{
          name: 'Adaugare contract',
          name: 'Documente',
          params: { clientId: client.id },
        }"><v-btn color="orange" class="mx-2 my-2">Vezi documente</v-btn></router-link>

        <router-link :to="{
          name: 'Note',
          params: { clientId: client.id },
        }"><v-btn color="primary darken-1" class="mx-2 my-2">Mergi la note</v-btn></router-link>
      </v-layout>

      <v-form ref="form" v-model="valid">
        <v-text-field v-if="client.id !== undefined" label="ID" v-model="client.id" disabled>
        </v-text-field>
        <v-text-field label="Detinator/Utilizator" v-model="client.name" :rules="nameRules" required></v-text-field>


        <v-text-field label="Telefon" v-model="client.phone" :rules="phoneRules" required
          hint="Incepe obligatoriu cu 40 pentur Romania. Pot fi atasate mai multe numere delimitate de caracterul '/'"
          persistent-hint>
        </v-text-field>

        <v-text-field label="Email" v-model="client.email" :rules="emailRules">
        </v-text-field>

        <v-text-field label="Judet" v-model="client.county" :rules="countyRules" required>
        </v-text-field>

        <v-text-field label="Localitate / Sector" v-model="client.city" :rules="cityRules" required>
        </v-text-field>

        <v-text-field label="Strada, nr." v-model="client.street" :rules="streetRules" required>
        </v-text-field>

        <v-text-field label="Bl., sc., et., ap." v-model="client.addressDetails" :rules="addressDetailsRules"
          required></v-text-field>

        <div v-if="!this.hasRole(this.PERMISSION_LEVEL_TECHNICIAN_ANRE)">
          <v-text-field label="CNP" v-model="client.cnp"></v-text-field>

          <v-text-field label="Contract nr" v-model="client.contractNr" :rules="contractNrRules"
            required></v-text-field>

          <v-text-field label="Valoare Contract" v-model="client.contractValue" :rules="contractValueRules"
            required></v-text-field>

          <v-text-field label="Raport de verificare Nr./ Data" v-model="client.deviceCheckReport">
          </v-text-field>
        </div>

        <v-text-field label="Livret aparat Nr. /data" v-model="client.deviceCheckReport">
        </v-text-field>

        <div v-if="!this.hasRole(this.PERMISSION_LEVEL_TECHNICIAN_ANRE)">
          <v-text-field label="Admiterea functionarii - VTP - Reparare" v-model="client.operation"
            :rules="operationRules" required></v-text-field>

          <v-text-field label="Modelul aparatului" v-model="client.deviceType" :rules="deviceTypeRules"
            required></v-text-field>

          <v-text-field label="Parametrii principali ai aparatului" v-model="client.deviceFeatures"
            :rules="deviceFeaturesRules" required></v-text-field>

          <v-text-field label="Nr. Fabricatie / an de fabricatie" v-model="client.deviceRelease"
            :rules="deviceReleaseRules" required></v-text-field>

          <v-text-field label="Producator/furnizor" v-model="client.deviceManufacter" :rules="deviceManufacterRules"
            required></v-text-field>

          <v-text-field label="Aparatul este montat mural in" v-model="client.devicePlace" :rules="devicePlaceRules"
            required>
          </v-text-field>

          <v-text-field label="Observatii" v-model="client.observations"></v-text-field>

          <v-text-field label="Serie certificat garantie/factura achizitie" v-model="client.contract"></v-text-field>

          <v-text-field label="Tip Aparat" v-model="client.livretType">
          </v-text-field>

          <v-menu ref="menuRevisionDate" v-model="menuRevisionDate" :close-on-content-click="false"
            :return-value.sync="client.revisionDate" transition="scale-transition" offset-y min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="client.revisionDate" label="Ultima revizie" prepend-icon="event" readonly v-on="on"
                :rules="revisionDateRules"></v-text-field>
            </template>
            <v-date-picker v-model="client.revisionDate" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="menuRevisionDate = false">Cancel</v-btn>
              <v-btn text color="primary" @click="$refs.menuRevisionDate.save(client.revisionDate)">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </div>

        <div
          v-if="!this.hasRole(this.PERMISSION_LEVEL_TECHNICIAN_ANRE) || (this.hasRole(this.PERMISSION_LEVEL_TECHNICIAN_ANRE) && client.checkDate)">
          <v-menu ref="menuCheckDate" v-model="menuCheckDate" :close-on-content-click="false"
            :return-value.sync="client.checkDate" transition="scale-transition" offset-y min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="client.checkDate" label="Ultima Verificare ISCIR" prepend-icon="event" readonly
                v-on="on" :rules="checkDateRules"></v-text-field>

              <p v-if="new Date(client.checkDate).getTime() === 0" class="blue--text"> Urmatoarea verificare se va
                efectua la cererea clientului.</p>

            </template>
            <v-date-picker v-model="client.checkDate" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="menuCheckDate = false">Cancel</v-btn>
              <v-btn text color="primary" @click="$refs.menuCheckDate.save(client.checkDate)">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </div>

        <h2>Instalatie Gaz</h2>

        <v-text-field label="Codul locului de consum" v-model="client.consumptionPlaceCodeAnre"
          :rules="requiredRulesForAnreTechnician">
        </v-text-field>

        <v-text-field label="Numar Documentatia tehnica in baza careia se efectueaza verificarea tehnica"
          v-model="client.technicalDocumentationNrAnre" :rules="rulestechnicalDocumentationNrAnreTechnician">
        </v-text-field>

        <v-text-field label="An Documentatia tehnica in baza careia se efectueaza verificarea tehnica"
          v-model="client.technicalDocumentationYearAnre" :rules="numberRulesForAnreTechnician">
        </v-text-field>

        <v-menu ref="menuCheckDateAnre" v-model="menuCheckDateAnre" :close-on-content-click="false"
          :return-value.sync="client.checkDateAnre" transition="scale-transition" offset-y min-width="290px">
          <template v-slot:activator="{ on }">
            <v-text-field v-model="client.checkDateAnre" label="Ultima verificare Gaz" prepend-icon="event" readonly
              v-on="on" :rules="checkDateAnreRules"></v-text-field>
          </template>
          <v-date-picker v-model="client.checkDateAnre" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menuCheckDateAnre = false">Cancel</v-btn>
            <v-btn text color="primary" @click="$refs.menuCheckDateAnre.save(client.checkDateAnre)">OK</v-btn>
          </v-date-picker>
        </v-menu>

        <v-switch label="Client Special" v-model="client.isSpecial" class="mx-2"></v-switch>
        <v-textarea label="De ce este special?" v-if="client.isSpecial" v-model="client.specialNotes">
        </v-textarea>

        <v-switch label="Activ" v-model="client.isActive" class="mx-2"></v-switch>

        <div class="text-xs-right">
          <v-btn @click="submit" color="primary">Salvare</v-btn>
        </div>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
import { hasAccess, hasRole, PERMISSION_LEVEL_TECHNICIAN_ANRE } from '../../utils/permissions';

export default {
  name: 'clients-form',
  props: ['client', 'onSubmit'],
  data() {
    return {
      valid: true,
      menuRevisionDate: false,
      menuCheckDate: false,
      menuCheckDateAnre: false,
      nameRules: [
        (element) => {
          if (element.trim() === '') return 'Numele trebuie completat.';
          return true;
        },
      ],

      phoneRules: [
        (e) => {
          const phoneNumbers = e.split('/');

          // eslint-disable-next-line no-plusplus
          for (let index = 0; index < phoneNumbers.length; index++) {
            const element = phoneNumbers[index];

            if (element.trim() === '') {
              return `Numarul de telefonul ${index + 1} trebuie completat.`;
            }

            // eslint-disable-next-line no-restricted-globals
            if (isNaN(element)) {
              return `Numarul de telefonul ${index + 1
                } trebuie sa fie numeric.`;
            }

            if (/^(?=07)\+?\d+(?:[\s\-.]?\d+)*$/.test(element)) {
              return `Numarul de telefonul ${index + 1} trebuie sa respecte formatul international. Ex. Romania 407X-XXX-XXX`;
            }
          }

          return true;
        },
      ],

      numberRules: [
        (e) => {
          if (isNaN(e)) {
            return 'Numarul trebuie sa fie de tip numeric.';
          }
          return true;
        },
      ],

      emailRules: [
        (v) => {
          if (!v || v.trim() === '') return true;

          const emailRegex = /[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/;
          return emailRegex.test(v) || 'E-mail nu este valid';
        },
      ],
      contractNrRules: [
        (element) => {
          if (element === 0) {
            return 'Numarul de contract trebuie completat cu o valoare valida.';
          }

          return true;
        },
      ],
      contractValueRules: [
        (element) => {
          if (element === 0) {
            return 'Valoarea contractului trebuie completata cu o valoare valida.';
          }
          return true;
        },
      ],
      cityRules: [
        (element) => {
          if (element.trim() === '') return 'Localitate / Sector trebuie completat.';
          return true;
        },
      ],
      countyRules: [
        (element) => {
          if (element.trim() === '') return 'Judetul trebuie completat.';
          return true;
        },
      ],
      streetRules: [
        (element) => {
          if (element.trim() === '') return 'Judetul trebuie completat.';
          return true;
        },
      ],
      addressDetailsRules: [
        (element) => {
          if (element.trim() === '') return 'Adresa trebuie completata.';
          return true;
        },
      ],
      operationRules: [
        (element) => {
          if (element.trim() === '') {
            return 'Operatia efectuata trebuie completata.';
          }
          return true;
        },
      ],
      deviceTypeRules: [
        (element) => {
          if (element.trim() === '') {
            return 'Tipul aparatului trebuie completat';
          }
          return true;
        },
      ],
      deviceFeaturesRules: [
        (element) => {
          if (element.trim() === '') {
            return 'Caracteristicilie aparatului trebuiesc completate.';
          }
          return true;
        },
      ],
      deviceReleaseRules: [
        (element) => {
          if (element.trim() === '') {
            return 'Data de fabricatie a aparatului trebuie completata.';
          }
          return true;
        },
      ],
      deviceManufacterRules: [
        (element) => {
          if (element.trim() === '') {
            return 'Producatorul aparatului trebuie completat.';
          }
          return true;
        },
      ],
      devicePlaceRules: [
        (element) => {
          if (element.trim() === '') return 'Amplasarea trebuie completata.';
          return true;
        },
      ],
      revisionDateRules: [
        (element) => {
          if (element === '') {
            return 'Data urmatoarei revizii trebuie completata.';
          }
          return true;
        },
      ],
      checkDateRules: [
        (element) => {
          if (element === '') {
            return 'Data urmatoarei verificari trebuie completata.';
          }
          return true;
        },
      ],

      requiredRulesForAnreTechnician: [
        (element) => {
          if (hasRole(this.PERMISSION_LEVEL_TECHNICIAN_ANRE) && element.trim() === '') {
            return 'Campul nu a fost completat.';
          }
          return true;
        },
      ],

      rulestechnicalDocumentationNrAnreTechnician: [
        (element) => {
          if (element.trim() === '') return 'Numar documentatie tehnica trebuie completat.';
          return true;
        },
      ],

      numberRulesForAnreTechnician: [
        (e) => {
          if (hasRole(this.PERMISSION_LEVEL_TECHNICIAN_ANRE)) {
            if (e === '') {
              return 'Campul nu a fost completat.';
            } else if (isNaN(e)) {
              return 'Numarul trebuie sa fie de tip numeric.';
            }
          }
          return true;
        },
      ],

      checkDateAnreRules: [
        (element) => {
          if (hasRole(this.PERMISSION_LEVEL_TECHNICIAN_ANRE) && !element) {
            return 'Campul nu a fost completat.';
          }
          return true;
        },
      ],

      PERMISSION_LEVEL_TECHNICIAN_ANRE,
    };
  },
  methods: {
    hasAccess,
    hasRole,

    gotoNotes() {
      this.$router.push({ path: `/clients/${this.$route.params.id}/notes` });
    },
    submit() {
      this.client.deviceLivret = this.client.deviceCheckReport;

      if (this.$refs.form.validate() && this.valid) {
        this.onSubmit();
      }
    },
  },
};
</script>

<style scoped>
.color-default a button {
  color: white;
  text-decoration: none;
}
</style>
